module.exports = __webpack_public_path__ + "media/img/dowod_rejestracyjny@2x-ef0b339a.png";